const itemsData = {
  Id: 0,
  boxLines: [
    {
      rowList: [
        { title: "付款单号: ", banding: "Code", value: "", className: 'c-code-color' },
        { title: "申请日期: ", banding: "ApplyDate", value: "", dataType: "Date" }
      ]
    },
    {
      rowList: [
        { title: "申请金额: ", banding: "ApplyAmount", value: "", className: 'c-amount-color' },
        { title: "付款日期:  ", banding: "PayDate", value: "", dataType: "Date" }
      ]
    },
    {
      rowList: [
        {
          title: "备注: ",
          banding: "Remark",
          value: ""
        }
      ]
    }
  ]
};

const itemsDetailData = {
  boxLines: [
    {
      rowList: [
        { title: "订单号: ", banding: "OrderNo", value: "", className: 'c-code-color' },
        { title: "申请付款: ", banding: "ApplyAmount", value: "", className: 'c-amount-color' },
      ]
    },
    {
      rowList: [
        { title: "应付关税: ", banding: "TariffFee", value: "", className: 'c-unAmount-color' },
        { title: "应付增值税:  ", banding: "VATFee", value: "" , className: 'c-unAmount-color'}
      ]
    },
    {
      rowList: [
        { title: "应付代理费: ", banding: "TariffFee", value: "", className: 'c-unAmount-color' },
        { title: "应付杂费:  ", banding: "VATFee", value: "", className: 'c-unAmount-color'}
      ]
    },

  ]
};
export { itemsData, itemsDetailData };
